import React, { useState } from "react";
import { Accordion, AccordionDetails } from "@mui/material";
import CollapsibleCardHeader from "../collapsible-card-header/CollapsibleCardHeader";
import "./collapsibleCard.scss";

interface ICollapsibleCardProps {
	headerTitle: string;
	className?: string;
	isExpanded: boolean;
	children: React.ReactNode;
	onToggle: (expanded: boolean) => void;
}

const CollapsibleCard: React.FC<ICollapsibleCardProps> = ({
	headerTitle,
	children,
	className,
	isExpanded,
	onToggle,
}) => {
	return (
		<Accordion className={`collapsibleCard ${className || ""}`} expanded={isExpanded} disableGutters>
			{/* Header Section */}
			<CollapsibleCardHeader
				isExpanded={isExpanded}
				title={headerTitle}
				handleToggle={() => onToggle(!isExpanded)}
			/>
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
};

export default CollapsibleCard;
